import { yup } from '@/libs/yup';

export const schema = yup.object({
  healthCheckupInstitutionId: yup
    .string()
    .max(5)
    .matches(/^[a-zA-Z0-9_-]+$/, {
      message: ({ label }) => `${label}は半角英数・ハイフン・アンダーバーで入力してください`,
      excludeEmptyString: true
    })
    .required()
    .label('ID'),
  name: yup.string().max(120).required().label('健康診断実施機関名'),
  location: yup.string().max(120).required().label('所在地')
});

export type Schema = yup.InferType<typeof schema>;

export const defaultValues = {
  healthCheckupInstitutionId: '',
  name: '',
  location: ''
} satisfies Schema;
